// extracted by mini-css-extract-plugin
module.exports = {"Nav":"menu_Nav__xipD6","Selected":"menu_Selected__akAYM"};